import React from "react";
import PropTypes from "prop-types";
import { Card, Typography } from "antd";
import { formatCurrency } from "utilities/currency";

const { Paragraph } = Typography;

class CreditAppraisalProposedLimit extends React.Component {
    onChange = value => {
        this.value = value;
        this.props.update(this.value && Number(this.value.replace(/,/g, "")));
    };
    render() {
        if (!this.value) {
            this.value = formatCurrency(this.props.proposedLimit, true);
        }
        return (
            <Card className={"small-card-title"} title={"Proposed Limit"}>
                <Paragraph
                    editable={(!this.props.isRiskApprover && this.props.isUserAllowedToEdit) && !this.props.recreditViewOnlyPermission ? {
                        onChange: this.onChange
                    } : false}
                    className={"d-flex justify-content-space-between"}
                    level={3}
                >
                    {this.value}
                </Paragraph>
            </Card>
        );
    }
}

CreditAppraisalProposedLimit.propTypes = {
    proposedLimit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    update: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    isUserAllowedToEdit: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default CreditAppraisalProposedLimit;
